(() => {
  const SAMPLE_VARIANT_ID = 59471097725253;

  let syncing = false;

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    });
    return response.json();
  }

  async function addSamplePack() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: SAMPLE_VARIANT_ID,
          quantity: 1,
          properties: {
            '_that_skn_free_samples': 'true'
          }
        }]
      })
    });
  }

  async function setSampleQuantity(lineKey, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });
  }

  async function syncSamples() {
    if (syncing) return;
    syncing = true;

    try {
      const cart = await getCart();

      const sampleLines = cart.items.filter(
        item => Number(item.variant_id) === SAMPLE_VARIANT_ID
      );

      const regularItems = cart.items.filter(
        item => Number(item.variant_id) !== SAMPLE_VARIANT_ID
      );

      const hasRegularProduct = regularItems.length > 0;

      if (hasRegularProduct && sampleLines.length === 0) {
        await addSamplePack();
        window.location.reload();
        return;
      }

      if (!hasRegularProduct && sampleLines.length > 0) {
        for (const item of sampleLines) {
          await setSampleQuantity(item.key, 0);
        }
        window.location.reload();
        return;
      }

      if (sampleLines.length > 0) {
        let changed = false;

        if (sampleLines[0].quantity !== 1) {
          await setSampleQuantity(sampleLines[0].key, 1);
          changed = true;
        }

        for (let i = 1; i < sampleLines.length; i++) {
          await setSampleQuantity(sampleLines[i].key, 0);
          changed = true;
        }

        if (changed) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('THAT SKN samples:', error);
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', syncSamples);

  document.addEventListener('change', () => {
    setTimeout(syncSamples, 800);
  });

  document.addEventListener('click', event => {
    if (
      event.target.closest(
        'button, [name="add"], cart-remove-button, quantity-input'
      )
    ) {
      setTimeout(syncSamples, 1000);
    }
  });

  document.addEventListener('submit', () => {
    setTimeout(syncSamples, 1000);
  });
})();
//test
